import Vue from 'vue'
import SecureVHtmlTarget from 'directives/secure-v-html-target'

Vue.directive('secure-v-html-target', SecureVHtmlTarget)
